<div class="page-shell">
    <div class="page">
        <div class="hero">
            <div class="hero-text">
                <span class="eyebrow">Registration</span>
                @if (stage === 'verify-email') {
                <h2>Check your email</h2>
                <p>We sent a verification link{{ email ? ' to ' + email : '' }}. Confirm your email to continue onboarding.</p>
                }
                @if (stage !== 'verify-email') {
                <h2>Thanks for signing up</h2>
                <p>Your tenant registration is complete.</p>
                }
            </div>
            <div class="hero-panel">
                @if (stage === 'verify-email') {
                <div class="step-pill">Pending</div>
                <div class="hero-title">Email confirmation</div>
                <div class="hero-subtitle">Open the verification link to continue.</div>
                }
                @if (stage !== 'verify-email') {
                <div class="step-pill">Complete</div>
                <div class="hero-title">Next steps</div>
                <div class="hero-subtitle">We are excited to have you onboard.</div>
                }
            </div>
        </div>

        <section class="card">
            @if (stage === 'verify-email') {
            <h3>What happens now?</h3>
            <p>Open the verification email we just sent you. After you confirm your email, you will return here to finish account setup.</p>
            }
            @if (stage !== 'verify-email') {
            <h3>What happens now?</h3>
            <p>Continue to Atlas to select a plan and start checkout.</p>
            <div class="actions">
                <a class="primary-link" href="/atlas-signup">Go to Atlas signup</a>
                <a class="secondary-link" href="/">Return home</a>
            </div>
            }
        </section>

        @if (stage === 'verify-email') {
        <div class="actions page-actions">
            @if (tenantId) {
            <button class="primary-link" type="button" (click)="resendVerification()" [disabled]="resendInFlight">
                {{ resendInFlight ? 'Sending...' : 'Resend verification email' }}
            </button>
            }
            <a class="secondary-link" href="/">Return home</a>
        </div>
        }
    </div>
</div>
